import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ContactForm } from 'src/app/classes/form-groups/contact-form';
import { ContactService } from 'src/app/services/contact.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-edit-contact-type-modal',
  templateUrl: './edit-contact-type-modal.component.html',
  styleUrls: ['./edit-contact-type-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EditContactTypeModalComponent implements OnInit {
  constructor(
    private ActiveModal: NgbActiveModal,
    private ToastService: ToastService,
    private ContactService: ContactService
  ) {}

  @Input() VendorId?: number;
  @Input() ExemptVendorId?: number;
  @Input() ClientRegisteredVendorId?: number;
  @Input() ContactFormGroup!: ContactForm;

  save() {
    const {
      id,
      VendorId,
      ExemptVendorId,
      ClientRegisteredVendorId,
      isCompliance,
      isBid,
      isBilling,
      isPrimaryCompliance,
      isPrimaryBid,
      isPrimaryBilling
    } = this.ContactFormGroup.getRawValue();

    const ContactToSave = {
      id,
      VendorId,
      ExemptVendorId,
      ClientRegisteredVendorId,
      isCompliance,
      isBid,
      isBilling,
      isPrimaryCompliance,
      isPrimaryBid,
      isPrimaryBilling
    };

    this.ContactService.saveContact(ContactToSave).subscribe({
      next: (SavedContact) => {
        this.ActiveModal.close(SavedContact);
      }
    });
  }

  close() {
    this.ActiveModal.dismiss();
  }

  ngOnInit(): void {
    if (
      !this.VendorId &&
      !this.ExemptVendorId &&
      !this.ClientRegisteredVendorId
    ) {
      throw this.ToastService.addErrorToast('Error', 'Missing Vendor Id.', {
        returnError: true
      });
    }

    if (!this.ContactFormGroup) {
      throw this.ToastService.addErrorToast('Error', 'Missing Contact form.', {
        returnError: true
      });
    }
  }
}
